import { render, staticRenderFns } from "./InvestigationModuleForm.vue?vue&type=template&id=7693ee91&scoped=true"
import script from "./InvestigationModuleForm.vue?vue&type=script&lang=js"
export * from "./InvestigationModuleForm.vue?vue&type=script&lang=js"
import style0 from "./InvestigationModuleForm.vue?vue&type=style&index=0&id=7693ee91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7693ee91",
  null
  
)

export default component.exports